export default "/images/22f807579e7c7b2dd5e6fcb936a402d5.avif";